// change here to make it not accessible on mobile phones
const SCREEN_TYPE = {
  SUPPORTED: 0,
  NOT_SUPPORTED: -1,
  MOBILE: 3,
};

const PLAYER_MODE = {
  COLLAPSED: 0,
  EXPANDED: 1,
  MINI: 2,
  FULL: 3,
};

const WINDOW_MODE = {
  UN_MAX: 0,
  MINI: 1,
  MAX: 2,
};

const NAV_ROUTES = {
  HOME: 11,
  YOUR_PLAYLIST: 21,
  CREATE_PLAYLIST: 22,
  IMPORT_SPOTIFY: 23,
  IMPORT_YOUTUBE: 24,
  JOIN_SERVER: 21,
  CREATE_SERVER: 22,
};

const Z_INDEX = {
  navbar: 1005,
  electronHead: 31000,
  playerControls: 1010,
  playerSheet: 1000,
  momo: 5,
  miniWindow: 40000,
  modal: 30000,
  toast: 31015,
};

// const Z_INDEX = {
//   navbar: 200,
//   electronHead: 700,
//   playerControls: 400,
//   playerSheet: 300,
//   momo: 100,
//   miniWindow: 800,
//   modal: 500,
//   toast: 600,
// };

const IDs = {
  PLAYER_SHEET: "prefix_playerSheet",
  VIDEO_PLAYER: "prefix_videoPlayer",
  YOUTUBE_IFRAME: "prefix_ytPlayer",
};

const YT_VIDEO_STATE = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  VIDEO_CUED: 5,
};

const NAV_OPTIONS = {
  DRAWER: 0,
  PROFILE: 1,
  PLAYER: 2,
  LIBRARY: 3,
  SERVER: 4,
  IMPORT: 5,
  INFO: 6,
  DEVELOPER: 7,
};

const STATUS = { LOADING: 1, ERROR: 2, SUCCESS: 3 };

export {
  NAV_ROUTES,
  Z_INDEX,
  IDs,
  YT_VIDEO_STATE,
  NAV_OPTIONS,
  SCREEN_TYPE,
  PLAYER_MODE,
  STATUS,
  WINDOW_MODE,
};
